import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Typography } from '@hmsexp/component-library';
import styles from "./style"

const TabItem = ({
    label,
    value,
    subValue,
    subLabel,
    sparklineData,
    isActive,
    onPress,
    onHover,
    color = '#7cb5ec',
    subValueColor,
    sparklineConfig = {},
    symbol
}) => {
    const formattedData = sparklineData.map((point, index) => {
        if (index === sparklineData.length - 1 && symbol) {
            return {
                y: point,
                marker: {
                    enabled: true,
                    symbol: symbol,
                    radius: 4
                }
            };
        }
        return point;
    });

    const sparklineOptions = Highcharts.merge(sparklineConfig, {
        series: [
            {
                data: formattedData,
                color: color,
                fillColor: {
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, color],
                        [1, 'rgba(255,255,255,0)']
                    ]
                }
            }
        ]
    });
    return (
        <TouchableOpacity
            onPress={onPress}
            onMouseEnter={() => onHover && onHover(true)}
            onMouseLeave={() => onHover && onHover(false)}
            style={[styles.tabItemContainer, isActive && styles.activeContainer]}
        >
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', gap: 20, alignItems: 'center' }}>
                <View style={[styles.content]}>
                    <Typography variant='button' fontWeightType='bold' textProps={{ style: styles.label }}>{label}</Typography>
                    <Typography variant='h5' textProps={{ style: styles.value }}>{value}</Typography>
                </View>
                <View style={styles.chartContainer}>
                    <HighchartsReact highcharts={Highcharts} options={sparklineOptions} />
                </View>
            </View>
            <View style={styles.subInfo}>
                {subValue && (
                    <View style={[styles.badge, { backgroundColor: subValueColor ? 'transparent' : '#f0f0f0' }]}>
                        <Typography variant='button' fontWeightType='regular' style={[styles.subValue, subValueColor && { color: subValueColor }]}>{subValue}</Typography>
                    </View>
                )}
                {subLabel && <Typography variant='caption' fontWeightType='regular' style={styles.subLabel}>{subLabel}</Typography>}
            </View>
        </TouchableOpacity>
    );
};


export default TabItem;
